import { render, staticRenderFns } from "./StickyNotes.vue?vue&type=template&id=23c16178&scoped=true&"
import script from "./StickyNotes.vue?vue&type=script&lang=js&"
export * from "./StickyNotes.vue?vue&type=script&lang=js&"
import style0 from "./StickyNotes.vue?vue&type=style&index=0&id=23c16178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c16178",
  null
  
)

export default component.exports